(ns frontend.ux-overhaul.listing.tenant-kyc-profile.event
  (:require [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.view.entity :as entity]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::create-tenant-kyc-profile
 (fn [_ _]
   (entity/open-creator! :entity.type/tenant-kyc-profile {})
   {}))

(rf/reg-event-fx
 ::open-bulk-edit
 (fn [_ [_ {:keys [listing-id]}]]
   (rf/dispatch [::bulk-actions/open-bulk-edit {:listing-id listing-id}])
   {}))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   ;; Legacy tenant-kyc-grid reuses :kyc-profile/mass-action rather than
   ;; a dedicated :tenant-kyc-profile/mass-action - the backend handler
   ;; derives the real entity-type from the ids themselves, so this works
   ;; for tenant-kyc-profile too (see ai/mistakes.md).
   (bulk-actions/bulk-delete-selected!
    {:db        db
     :listing-id listing-id
     :operation :kyc-profile/mass-action
     :body-fn   (fn [ids]
                  {:action          :delete-kyc-profiles
                   :kyc-profile-ids ids})})
   {}))

(rf/reg-event-fx
 ::export-grid
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id  listing-id
                               :entity-type :entity.type/tenant-kyc-profile})
   {}))
